import axios from '../request/http';
// import {toFormData} from '../common/descriptions'

const goods = {
    // 商品列表
    goodsList(params) {
        return axios.get("/admin/goods/list", { params });
    },
    // 商品详情
    goodsDetail(params) {
        return axios.get("/admin/goods/detail", { params });
    },
    // 商品上下架
    goodsStatus(params) {
        return axios.get("/admin/goods/update/status", { params });
    },
    //商品订单列表
    orderGoodsList(params) {
        return axios.get("/admin/order/goods/list", { params });
    },
    //商品订单列表
    orderGoodsList(params) {
        return axios.get("/admin/order/goods/list", { params });
    },
     //更改订单状态
    orderGoodsUpdate(params) {
        return axios.get("/admin/order/status/update", { params });
    },
    // 上传订单报告
    orderGoodsUpload(params) {
        return axios.get("/admin/order/report/upload", { params });
    },
    // 售后列表
    orderGoodsAfter(params) {
        return axios.get("/admin/order/after-list", { params });
    },
   


    // 商品分类列表
    categoryListAll(params) {
        return axios.get("/admin/category/listAll", { params });
    },
    // 商品新增
    goodsAddGoods(data) {
        return axios.post("/admin/goods/add", data);
    },

    // 新增修改分类
    listAddEdit(data) {
        return axios.post("/admin/category/edit", data);
    },
    // 分类删除
    listDelete(params) {
        return axios.get("/admin/category/del", { params });
    },

    // 活动专区
    activityList(params) {
        return axios.get("/admin/activity/list", { params });
    },
    // 活动商品列表
    zoneGoodsList(params) {
        return axios.get("/admin/activity/goods/list", { params });
    },
    // 专区上下架
    activityStatus(params) {
        return axios.get("/admin/activity/status/update", { params });
    },
    // 删除专区
    activityModuleGoodsBatchDel(params) {
        return axios.get("/admin/activity/delete", { params });
    },
    // 删除专区商品
    activityGoodsDelete(params) {
        return axios.get("/admin/activity/goods/delete", { params });
    },
    // 专区更改
    activityEdit(data) {
        return axios.post("/admin/activity/edit", data);
    },
    // 专区商品上下架
    activityGoodsUpdate(params) {
        return axios.get("/admin/activity/goods/update", { params });
    },
    // 活动商品跟新
    activityModuleGoodsBatchAdd(data) {
        return axios.post("/admin/activity/goods/add", data);
    },
    specAdd(data) {
        return axios.post("/admin/goods/spec/add", data);
    },
    // 商品服务标签
    provideServiceList(params) {
        return axios.get("/admin/goods/tab/list", { params });
    },
    // 删除服务标签
    provideServiceDel(params) {
        return axios.get("/admin/goods/tab/delete", { params });
    },
    // 新增
    provideServiceAdd(data) {
        return axios.post("/admin/goods/tab/add", data);
    },
    // 修改评分
    fractionEdit(params) {
        return axios.get("/admin/goods/fraction/edit", { params });
    },


}



export default goods;



// WEBPACK FOOTER //
// ./src/api/goods.js